<div class="result">
  <highcharts-chart
    id="{{chartId}}"
    *ngIf= "isBrowser"
    [Highcharts]="Highcharts"

    [constructorType]="chartConstructor"
    [options]="chartOptions"

    class="test-cm-chart"
  ></highcharts-chart>
</div>
